// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-belmont -> aion-management-belmont -> aspen-court-apartment-homes
// Generated: 2026-10-22T20:07:46.435Z
// Counts: 1 design, 68 content, 63 slot group, 1 collection binding, 9 section, 9 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.pretitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 BEDROOM LAYOUTS</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>1 - 2 Bedroom Apartments for Rent in Piscataway , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Aspen Court Apartment Homes</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aspen Court Apartment Homes in Piscataway, NJ, where vibrant living meets convenience. Nestled near parks, esteemed schools, and the arts, your new home puts culture and recreation at your doorstep. Enjoy the vibrant atmosphere of Rutgers Gardens, or relax at Donaldson Park—adventure awaits just around the corner!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>tour anytime. from anywhere.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pinnedcallouts.title": {
    "overrideType": "VALUE",
    "customValue": "<p>We're Here For You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>your new home awaits</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Space, Your Home, Your Community</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Accessibility Statement</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, indulge in luxurious comfort with spacious one and two-bedroom layouts. Unwind by the sparkling swimming pool, energize in the fitness center, or enjoy a cozy evening by the firepit. Experience the perfect blend of modern living and community connection today.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Amenities</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Features</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Interior</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Amenities</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityOverline": {
    "overrideType": "VALUE",
    "customValue": "<h3>Community</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Apply Now</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Contact Us</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Floor Plans</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gallery</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Discover ideal apartments with patio or balcony in Fullerton, PA. Enjoy serene outdoor spaces with modern amenities at Fairmont Place.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/patio-balcony-apartments-fullerton-pa::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apartments with Patios &amp; Balconies in Fullerton, PA</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore the community layout</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Neighborhood</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Pet-friendly living guidelines</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Privacy Policy</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Resident Portal</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "<p>Download the Loft Resident Mobile App</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Schedule a Tour</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduletourform.form_block": {
    "overrideType": "VALUE",
    "customValue": "elise-schedule-tour-iframe",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Sitemap</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank You</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Virtual Tours</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, modern living meets comfort. Choose from spacious one or two-bedroom layouts featuring stylish kitchens and upscale amenities like a sparkling pool, fitness center, and inviting outdoor lounges. Enjoy convenience with online rent payment, resident libraries, and pet-friendly options. Lease online today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, you'll find thoughtfully designed one and two-bedroom floor plans tailored for your lifestyle. With a welcoming community and convenient amenities, it's more than just a place to live—it's home. Have questions? Contact our leasing team today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, we offer thoughtfully designed one and two-bedroom floor plans tailored for your lifestyle. Each space blends comfort with modern amenities, ensuring a welcoming retreat. Browse our available apartment homes and find your ideal living arrangement today! Your dream home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, vibrant living awaits within spacious one and two-bedroom floor plans. Immerse yourself in resort-style amenities, from the shimmering swimming pool and outdoor lounge with fire pit to the energizing fitness center and dog park. Picture yourself thriving in this beautifully landscaped community!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Aspen Court Apartment Homes in Piscataway, NJ, where vibrant living meets convenience. Nestled near parks, esteemed schools, and the arts, your new home puts culture and recreation at your doorstep. Enjoy the vibrant atmosphere of Rutgers Gardens, or relax at Donaldson Park—adventure awaits just around the corner!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodshowcase.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Stylish Apartment Living in Piscataway , NJ</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicycallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p>We’re a pet‑friendly community and we’re happy to welcome your cats and dogs. You can have up to 2 pets per apartment, with each pet up to 100 lb. Monthly pet rent is $50 per pet, and there is a one‑time, non‑refundable $350 pet fee.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, comfort meets convenience. Choose from spacious one and two-bedroom floor plans, complete with modern kitchens and chic finishes. Enjoy unrivaled amenities like a refreshing swimming pool, a vibrant clubhouse, and serene walking trails—all in a pet-friendly community. Elevate your lifestyle today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Enjoy seamless living with our resident portal—easily pay rent, schedule maintenance, and stay connected. Your ideal home awaits just a click away!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, you'll find thoughtfully designed one and two-bedroom floor plans that perfectly blend comfort and style. Ready to experience the vibrant community for yourself? Schedule a tour today and hear firsthand why our residents love calling Aspen Court home!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Thank you for your interest in Aspen Court Apartment Homes in Piscataway, NJ! With thoughtfully designed one and two-bedroom floor plans, your ideal living space awaits. A member of our team will reach out shortly to assist you in finding your perfect home at Aspen Court.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Nestled in the heart of Piscataway, NJ, Aspen Court Apartment Homes offers spacious one- and two-bedroom layouts designed for your comfort. Immerse yourself in our vibrant community—take a virtual tour today and envision your new home among lush landscapes and modern amenities. Your next chapter awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contact-hero.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Floor Plans"
      }
    }
  },
  "pinnedcallouts.cta2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/contact-us"
      }
    }
  },
  "propertyoverview.cta_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "View Availability & Pricing"
      }
    }
  },
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7e85-775e-8aee-32c0d22d8d3d.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Modern white kitchen with stainless-steel appliances and marble countertops."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c4fc-744f-85b2-e01dba74b923.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor resident lounge with a pool table, bar-height tables, and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c4fc-744f-85b2-e01dba74b923.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor resident lounge with a pool table, bar-height tables, and a wall-mounted TV."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ad0a-72a5-bb18-e939bfba06d7.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright orange-walled community gym with treadmills, elliptical, and weight machines."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c772-77cc-8c98-fa6ca98d9be3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Interior community lounge with blue ceiling, wood accent wall, and assorted seating."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7e85-775e-8aee-32c0d22d8d3d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern white kitchen with stainless-steel appliances and marble countertops."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7dd8-76e9-8394-fc395930d83b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room in an apartment with a sofa, TV on a wooden credenza, and a glass sliding door to a balcony."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-8ac8-73bd-a0ff-7237a7e70dd4.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a neatly made bed, two nightstands, lamps, and wall art."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-d435-711f-92bd-a739e2d3929c.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior view of a multi-building apartment complex with balconies under a blue sky."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5729-755f-9f4b-e4972c6ea24c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Johnson Park, a sprawling riverfront county park with picnic grounds and walking paths near Piscataway."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-787c-776d-9eca-9720e076ef7a.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Rutgers University–New Brunswick campus, the nearby flagship research university."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3c16-73da-a720-0f58d8a4a04c.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "State Theatre New Jersey, a historic performing arts venue in nearby New Brunswick."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-a51b-7338-ac06-38de710ac4b4.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor pool at a residential community with lounge chairs and orange umbrellas."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ab6b-77dc-aedd-683e0f7cb281.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community pool with lounge chairs and orange umbrellas, surrounded by apartment buildings."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-aebe-729f-b594-3606b7a28f87.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community courtyard with orange umbrellas, string lights, gravel ground, and seating."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-b6e0-71a1-ad03-34535e61a3c8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community courtyard with orange Adirondack chairs around a fire pit and string lights."
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$250"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.certificate": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Certificate of Occupancy"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$100"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10% MPR"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.storage": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Storage"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$130"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500 - $1,000"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$12"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$5"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "floorplanslist.card_image_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fce68-015b-7377-a07d-37dc2757f900.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0267-ed99-717b-ba18-135639036155.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Modern apartment bedroom with a bed, dresser, plant, and a large window."
      }
    }
  },
  "floorplanslist.card_image_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fce68-0284-7511-aeeb-ec8969a50a75.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fce68-02e1-70be-b971-cf1083e1c506.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "blank transparent image"
      }
    }
  },
  "floorplanslist.card_image_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0268-06e1-722d-a964-3ebd3190ee9b.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bright living room in a modern apartment with a sofa, TV, and glass balcony doors."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019ffbbf-4a5c-71a3-b1d3-b643bdb5a41f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Panera Bread"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Bakery"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.1"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Counter-serve bakery-cafe serving fresh sandwiches, salads and soups, known for its artisan bread, morning pastries and free WiFi."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2600-754b-9a57-28488b592477.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Walmart"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Big, well-stocked superstore offering groceries, home furniture, appliances, toys, apparel, electronics and everyday essentials under one roof."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5729-755f-9f4b-e4972c6ea24c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Johnson Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Parks & Green Space"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling 473-acre riverfront park with a historic village, picnic grounds, sport courts, two ponds and shaded walking paths."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-194f-716f-8714-c36d3c1e38e4.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Cafe Nune"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Brunch"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "5.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Laid-back eatery specializing in açaí and sweet bowls, fresh salads and custom-made juices — a bright pick for brunch."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3929-7738-8878-6442d32199b8.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Zimmerli Art Museum"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "7.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "One of the nation's largest university museums at Rutgers, with more than 60,000 works of ancient and modern art from around the world."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5dbf-706d-9e91-2c74024091f5.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Middlesex County Open Space Greenway"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Recreation & Trails"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Kid-friendly paved greenway with a bridge, ideal for walking, biking, rollerblading and skating right in the neighborhood."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0b83-7638-83a9-ae93dc082898.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Gabriele's Bar & Grill"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Grill"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Local tavern serving American and Italian classics alongside games including pool, darts and bowling — a go-to for a casual night out."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3c16-73da-a720-0f58d8a4a04c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "State Theatre New Jersey"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music & Entertainment"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "7.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Historic nonprofit performance venue in New Brunswick showcasing live music, comedy, plays and touring acts year-round."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-129b-7629-ac1c-4a82c416066e.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Panico's Restaurant & Bar"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fine Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "7.4"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Refined Italian restaurant and bar specializing in brick-oven pizza plus hearty pasta dinners — a great pick for an evening meal."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1895-777a-a020-f8714a0d8a77.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Stuff Yer Face"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Late-Night"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "6.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lively bi-level spot known for stromboli sandwiches and a huge international beer list, plus burgers and pizza for late-night hangs."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3521-74cb-a12f-2d59af6852e0.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Rutgers Cinema"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cinema & Theater"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Independent movie theater on the Rutgers campus featuring blockbuster films and weekly concession specials."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1308-72ed-92a5-9742a67f428b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "25 Burgers"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Late-Night Eats"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "7.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Familiar eatery slinging gourmet burgers, crispy fries and thick milkshakes — a satisfying after-hours stop."
      }
    }
  },
  "neighborhoodshowcase.photo1": {
    "sourceIndex": 32,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo2": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo3": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "neighborhoodshowcase.photo4": {
    "sourceIndex": 36,
    "fieldOverrides": null
  },
  "pinnedcallouts.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "propertyoverview.images": {
    "limit": 3,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_template:hyperlocal::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/air-conditioned-apartments-newport-news-city-harborstone-444::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/dog-park-apartments-newport-news-va-harborstone-222::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/extra-storage-apartments-fullerton-pa-469::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/fitness-center-apartments-23601-harborstone-366::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "featuring/pet-friendly-apartments-south-newport-news-harborstone-651::_section.ApartmentSyncSection": {
    "properties": {
      "backgroundColor": "#ffffff"
    }
  },
  "_section.InteractiveMapSection": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingTop": "50px",
      "paddingBottom": "50px"
    }
  }
};
